import { locationIds } from "../../../../core/enums";
import { capitalize } from "../../../../utils/capitalize";

export const formatLocation = (locationId: string) => {
  const label =
    Object.entries(locationIds).find(([_, id]) => locationId === id)?.[0] ??
    "Anywhere";
  return capitalize(label);
};
